import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// Firebase configuration based on environment
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_IS_PROD === "true"
      ? process.env.REACT_APP_FIREBASE_API_KEY_PROD
      : process.env.REACT_APP_FIREBASE_API_KEY_DEV,
  authDomain:
    process.env.REACT_APP_IS_PROD === "true"
      ? process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD
      : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV,
  projectId:
    process.env.REACT_APP_IS_PROD === "true"
      ? process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD
      : process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV,
  storageBucket:
    process.env.REACT_APP_IS_PROD === "true"
      ? process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD
      : process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV,
  messagingSenderId:
    process.env.REACT_APP_IS_PROD === "true"
      ? process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID_PROD
      : process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID_DEV,
  appId:
    process.env.REACT_APP_IS_PROD === "true"
      ? process.env.REACT_APP_FIREBASE_APP_ID_PROD
      : process.env.REACT_APP_FIREBASE_APP_ID_DEV,
  measurementId:
    process.env.REACT_APP_IS_PROD === "true"
      ? process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD
      : process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { app, analytics, storage };
